<template>
  <Hero class="hero-home" :content="hero" :link="hero.link" title-tag="div">
    <!-- :label="heroLabel" :label-link="heroLabelLink" -->
    <template #top>
      <div class="hero-home__right">
        <!-- <hero-key-label
          title="Старт продаж!"
          desc="1-Я ОЧЕРЕДЬ"
          hide-icon
          data-popup-with-chats
        /> -->
        <!-- <hero-key-label
          class="hero-home__warn"
          desc="На сайте идут<br>технические работы"
          title="Доступность лотов<br>уточняйте по телефону"
          hide-icon
        /> -->
      </div>
    </template>
    <template #bottom>
      <div class="hero-home__bottom">
        <!-- <second-timer
          v-if="timerActive"
          title=""
          subtitle="До повышения цен:"
          :date="new Date(...timerDate)"
        /> -->
        <CountdownTimer
          v-if="timerActive"
          :date="new Date(...timerDate)"
          class="timer"
        >
          <template #title>{{ "До повышения цен:" }}</template>
        </CountdownTimer>
      </div>
    </template>
    <template #btns>
      <div class="btns-list d-md-flex justify-content-center">
        <div class="btns-list__item">
          <button
            data-popup-with-chats
            class="btn btn-default"
            data-popup-with-chats-title="Связаться со&nbsp;специалистом"
          >
            Связаться со&nbsp;специалистом
          </button>
        </div>
      </div>
    </template>
    <template #bottom-right>
      <div class="hero-home__bottom-right">
        <div
          v-if="buildingProgressItems && buildingProgressItems.length"
          class="readiness-work"
        >
          <ProgressBar
            v-for="item of buildingProgressItems"
            :key="item.progress_name"
            class="readiness-work-header__item"
            :name="item.progress_name"
            :percent="item.progress_percent"
          />
        </div>

        <CountdownTimer
          v-if="timerActive"
          :date="new Date(...timerDate)"
          class="timer-mobile"
        >
          <template #title>{{ "До повышения цен:" }}</template>
        </CountdownTimer>
      </div>
    </template>
  </Hero>
</template>

<script>
import Hero from "@/components/Hero.vue";
// import SecondTimer from "@/components/SecondTimer.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";
import HeroKeyLabel from "@/components/home/HeroKeyLabel.vue";
import ProgressBar from "@/components/home/ProgressBar.vue";

export default {
  components: {
    Hero,
    // SecondTimer,
    CountdownTimer,
    HeroKeyLabel,
    ProgressBar,
  },
  inject: ["mainStore", "mq"],
  computed: {
    buildingProgressItems() {
      return this.mainStore.state.data?.building_progress?.building_progress?.filter(
        (item) => item.progress_active
      );
    },
    offer() {
      return this.mainStore.state.data?.main_offer;
    },
    hero() {
      return {
        title: this.offer?.title,
        subtitle: this.offer?.subtitle,
        text: this.offer?.addition_text,
        link: "",
        images: {
          srcSet: this.offer?.picture,
          alt: "render",
          default: require("@/assets/i/banners/desk.jpg"),
        },
        more: "Начните знакомство с&nbsp;кварталом",
      };
    },
    heroLabel() {
      let text = "Ипотека";
      if (this.mainStore.state.data?.mortgage.min_mortgage_percent) {
        text =
          "Ипотека от&nbsp;" +
          this.mainStore.state.data.mortgage.min_mortgage_percent +
          "%";
      }
      return text;
    },
    heroLabelLink() {
      return "Purchase";
    },
    timerActive() {
      return this.mainStore.state.data?.couter_index?.is_active;
    },
    timerDate() {
      const dateEnd = this.mainStore.state.data?.couter_index?.date_end;
      if (!dateEnd) return [1970, 1, 1, 0, 0];

      const [datePart, timePart] = dateEnd.split(" ");
      const [y, m, d] = datePart.split("-").map(Number);
      const [hh, mm] = timePart.split(":").map(Number);

      return [y, m - 1, d, hh, mm];
    },
  },
};
</script>

<style lang="scss" scoped>
.hero-home__bottom {
  width: 100%;
  text-align: left;
  position: absolute;
  left: 32px;
  bottom: 35px;
  font-size: 16px;
}
/* .hero-home__bottom ul {
		position: relative;
		display: inline-flex;
		margin: 0px;
		padding: 0px;
		list-style: none;
		z-index: 1;
	}
	.hero-home__bottom li {
		margin: 0px 25px 0px 0px;
		padding: 0px;
	}
	.hero-home__bottom li a {
		text-decoration: none;
	} */
@media (max-width: 767px) {
  .hero-home :deep(.content) {
    min-height: 600px;
  }
}

.hero-home :deep(.label h5),
.hero-home :deep(.label .h5) {
  padding: 11px 19px 12px;
  border-radius: 26px;
  font-size: 19px;
}
@media (max-width: 767px) {
  .hero-home :deep(.label h5),
  .hero-home :deep(.label .h5) {
    padding: 9px 16px;
    font-size: 15px;
  }
}

.hero-home :deep(.title) {
  max-width: 800px;
}
@media (min-width: 1280px) {
  .hero-home :deep(.title) {
    font-size: 120px;
    text-transform: uppercase;
  }
}
@media (max-width: 767px) {
  .hero-home :deep(.title) {
    font-size: 48px;
    line-height: 42px;
  }

  .btns-list {
    margin-top: 12px;
  }

  .hero-home__bottom {
    bottom: 0;
    top: 170px;
    left: 0;
  }
}

.btns-list {
  margin-top: 20px;
}

.btns-list__item {
  position: relative;
  z-index: 10;
}

.hero-home :deep(.text) {
  max-width: 700px;
  font-weight: 500;
  line-height: 130%;
}

.hero-home :deep(.background::after) {
  background: rgb(41 31 31 / 0.2);
}

.hero-home__top {
  position: absolute;
  top: 110px;
  left: 0;
  font-weight: 500;
  /* width: 100%; */
  font-size: 16px;
  text-align: left;
}

.hero-home__top h1 {
  margin: 0;
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  letter-spacing: inherit;
}

.hero-home__right {
  position: absolute;
  top: 81px;
  right: 32px;
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
}

.hero-home__warn {
  background-color: #ff0010;
  color: #fff;
  text-align: right;
}

.hero-home:deep(.ms-key-lable) {
  cursor: pointer;
}

.hero-home__warn:deep(.ms-key-lable__text-desc) {
  text-transform: uppercase;
}

.hero-home__warn:deep(.ms-key-lable__text-title) {
  text-align: right;
}

.hero-home__bottom-right {
  position: absolute;
  right: 32px;
  bottom: 32px;
}

.readiness-work {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@media (max-width: 1200px) {
  .hero-home__right {
    gap: 8px;
  }

  .hero-home__stage-of-sale,
  .hero-home__warn {
    margin-right: 8px;
  }

  .hero-home__stage-of-sale {
    order: 1;
  }

  .hero-home__right {
    right: 5px;
  }
  .hero-home__bottom-right {
    left: 5px;
    top: 81px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .readiness-work {
    gap: 5px;
  }
}

@media (max-width: 350px) {
  .hero-home__bottom-right {
    top: 130px;
  }
}

.timer-mobile {
  display: none;

  @include lg {
    display: none;
  }

  @include md {
    display: flex;
  }
}

.timer {
  @include md {
    display: none;
  }
}
</style>
